import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4add5052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "columns is-tablet" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "accounts card custom-card custom-card-padding" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "notification is-danger is-light"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Une erreur inattendue est survenue pendant le chargement de la liste de demandes de crédits. Veuillez nous excuser pour le désagrément. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vous pouvez essayer de recharger la page, ou contacter votre administrateur si l'erreur persiste. ", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "notification is-default"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "custom-card-title" }, " Opérations de crédit en attente de validation ", -1))
const _hoisted_14 = { class: "table is-striped is-fullwidth" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "row-user-header" }, "Utilisateur"),
    /*#__PURE__*/_createElementVNode("th", { class: "row-amount-header" }, "Montant"),
    /*#__PURE__*/_createElementVNode("th", { class: "row-validate-header has-text-right" }, " Valider ")
  ])
], -1))
const _hoisted_16 = { class: "row-user" }
const _hoisted_17 = { class: "has-text-right" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": false,
              "is-full-page": false
            }, null, 8, ["active"]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.hasLoadingError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                    : (_ctx.pendingCreditRequests.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Aucune demande de crédit en attente de validation "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("table", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingCreditRequests, (request) => {
                                return (_openBlock(), _createElementBlock("tr", null, [
                                  _createElementVNode("td", _hoisted_16, _toDisplayString(request.relatedUser) + " " + _toDisplayString(request.markBackend ? `(on ${request.backendId})` : ""), 1),
                                  _createElementVNode("td", null, _toDisplayString(parseFloat(request.amount).toLocaleString("fr", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })) + " " + _toDisplayString(request.currency), 1),
                                  _createElementVNode("td", _hoisted_17, [
                                    _createElementVNode("a", {
                                      class: "button is-primary custom-button custom-inverted is-small is-pulled-right",
                                      onClick: ($event: any) => (_ctx.validateCreditRequest(request))
                                    }, " valider ", 8, _hoisted_18)
                                  ])
                                ]))
                              }), 256))
                            ])
                          ])
                        ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}